module.exports = __webpack_public_path__ + "assets/img/13b.dd60f23f.jpg";